export function PathsFinder() {
  const skillPacks = [
    {
      label: 'Career & Purpose',
      description: 'Find direction in work and discover what drives you',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=300&fit=crop',
      gradient: 'from-slate-900/60 to-slate-900/40',
    },
    {
      label: 'Relationships',
      description: 'Build deeper connections and communicate better',
      image: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=400&h=300&fit=crop',
      gradient: 'from-coral-900/60 to-coral-700/40',
    },
    {
      label: 'Health & Habits',
      description: 'Create routines that stick and feel good',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=400&h=300&fit=crop',
      gradient: 'from-sage-900/60 to-sage-700/40',
    },
    {
      label: 'Mental Wellness',
      description: 'Manage stress, anxiety, and find inner peace',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=400&h=300&fit=crop',
      gradient: 'from-slate-800/60 to-slate-600/40',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            What's on your mind?
          </h2>
          <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto">
            Your coach adapts to whatever you're working through - and checks in to keep you moving forward
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {skillPacks.map((pack, index) => (
            <div
              key={index}
              className="group relative h-64 sm:h-72 rounded-2xl overflow-hidden cursor-pointer"
            >
              <img
                src={pack.image}
                alt={pack.label}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${pack.gradient}`} />
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <h3 className="font-heading text-xl font-bold text-white mb-2">
                  {pack.label}
                </h3>
                <p className="text-white/80 text-sm leading-relaxed">
                  {pack.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-slate-500">
            Switch topics anytime. Your coach remembers everything.
          </p>
        </div>
      </div>
    </section>
  );
}
